document.addEventListener('DOMContentLoaded', function () {
  class YGSwiper extends HTMLElement {
    constructor() {
      super()
    }
    connectedCallback() {
      this.getAllAttributes()
      this.initSwiper()
    }

    get getCurrentSlidesPerView() {
      if (!this['breakpoints']) return 1;

      const screenWidth = window.innerWidth;

      // 将breakpoints按数值从小到大排序
      const sortedKeys = Object.keys(this['breakpoints']).map(Number).sort((a, b) => a - b);

      let current = sortedKeys[0]; // 默认取最小的

      // 遍历找到小于等于当前屏幕宽度的最大key
      for (let i = 0; i < sortedKeys.length; i++) {
        if (screenWidth >= sortedKeys[i]) {
          current = sortedKeys[i];
        } else {
          break;
        }
      }

      return this['breakpoints'][current].slidesPerView;
    }

    getAllAttributes() {
      let booleanAttrs = ['loop', 'pagination', 'navigation', 'scrollbar', 'centered-slides'];
      let jsonAttrs = ['breakpoints']
      for (const attr of this.attributes) {
        if (attr.name.startsWith('data-')) {
          const cleanName = attr.name.slice(5); // 去除 'data-' 前缀

          let value = attr.value;
          if (booleanAttrs.includes(cleanName)) {
            value = value === 'true';
          } else if (jsonAttrs.includes(cleanName)) {
            value = this.parseSwiperBreakpoints(value);
          }

          this[cleanName] = value;
        }
      }
    }

    parseSwiperBreakpoints(str) {
      const result = {};
      const pairs = str.split(',');

      for (const pair of pairs) {
        const [breakpoint, values] = pair.split(':');
        if (!breakpoint || !values) continue;

        const [slides, space] = values.split('-').map(Number);

        result[breakpoint.trim()] = {
          slidesPerView: slides,
          spaceBetween: space
        };
      }

      return result;
    }

    initSwiper() {
      const swiper = new Swiper(this, {
        // 这里放置 swiper 的配置
        effect: this['effect'],
        loop: this['loop'],
        centeredSlides: this['centered-slides'],
        autoplay: this['autoplay'] ? {
          delay: this['autoplay'],
          stopOnLastSlide: false,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        } : false,
        pagination: this['pagination'] ? {
          el: '.swiper-pagination',
          clickable: true,
        } : false,
        navigation: this['navigation'] ? {
          nextEl: this['navigation-class'] ? `.${this['navigation-class']}-next` : '.swiper-button-next',
          prevEl: this['navigation-class'] ? `.${this['navigation-class']}-prev` : '.swiper-button-prev',
        } : false,
        scrollbar: this['scrollbar'] ? {
          el: ".swiper-scrollbar",
          hide: true,
        } : false,
        breakpoints: this['breakpoints'] ? this['breakpoints'] : false,
        on: {
          init: e => {
            if (e.passedParams.loop) {
              let num = this.getCurrentSlidesPerView;
              let sliderLength = e.slides.length;

              if (this['centered-slides']) {
                num += 4;
              }

              if (sliderLength <= num) {
                for (let index = 1; index < Math.ceil(num / sliderLength); index++) {
                  e.slides.forEach((slide) => {
                    const clonedElement = slide.cloneNode(true);
                    e.slidesEl.appendChild(clonedElement);
                  })
                }

                setTimeout(() => {
                  let $bullets = this.querySelectorAll('.swiper-pagination-bullet');
                  $bullets.forEach((bullet, index) => {
                    if (index >= sliderLength) {
                      bullet.style.display = 'none';
                    }
                  })
                }, 250)
              }
            }
          }
        }
      })
    }
  }
  if (!window.customElements.get('yg-swiper')) {
    window.customElements.define('yg-swiper', YGSwiper)
  }

  class YGCountdown extends HTMLElement {
    constructor() {
      super();
      this.countdown();
    }

    countdown() {
      const cutOffTime = this.querySelector('.yg-countdown-timer').dataset.countdownTimer;
      const cunOffElemet = this.querySelector('.yg-countdown-timer');

      function updateTimer() {
        const time = (+new Date(cutOffTime) - Date.now()) / 1000;

        const days = Math.floor(time / (60 * 60 * 24));
        const hours = Math.floor((time % (60 * 60 * 24)) / (60 * 60));
        const minutes = Math.floor((time % (60 * 60)) / 60);
        const seconds = Math.floor(time % 60);
        const formattedDays = days.toString().padStart(2, '0');
        const formattedHours = hours.toString().padStart(2, '0');
        const formattedMinutes = minutes.toString().padStart(2, '0');
        const formattedSeconds = seconds.toString().padStart(2, '0');

        cunOffElemet.querySelector('.yg-countdown-days').innerHTML = formattedDays;
        cunOffElemet.querySelector('.yg-countdown-hours').innerHTML = formattedHours;
        cunOffElemet.querySelector('.yg-countdown-minutes').innerHTML = formattedMinutes;
        cunOffElemet.querySelector('.yg-countdown-seconds').innerHTML = formattedSeconds;
      }

      updateTimer();
      setInterval(updateTimer, 1000);
    }
  }

  if (!window.customElements.get('yg-countdown')) {
    window.customElements.define('yg-countdown', YGCountdown);
  }

  class YGAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      const header = this.querySelector('.yg-accordion-header');
      const content = this.querySelector('.yg-accordion-content');
      const hasParentAccordion = this.parentNode.closest('.yg-accordion');
      const isRetractableTab = this.classList.contains('yg-retractable-tab');
      const isTabItemAccordionFirst = this.classList.contains('yg-tab-item-accordion-first');
      const isTabItemAccordion = this.classList.contains('yg-tab-item-accordion');
      const downloadSection = this.closest('.yg-download-section');
      let allTabItemAccordions = null;
      if (downloadSection) {
        allTabItemAccordions = downloadSection.querySelectorAll('.yg-tab-item-accordion');
      }
      const contentHeight = content.scrollHeight;
      this.style.setProperty('--content-height', `${contentHeight}px`);

      if (isRetractableTab) {
        header.classList.add('active');
        content.classList.add('active');

        if (hasParentAccordion) {

          const originalContentHeight = hasParentAccordion.style.getPropertyValue('--content-height').replace('px', '');
          console.log(originalContentHeight, 'originalContentHeight');

          if (originalContentHeight) {
            console.log('contentHeight', contentHeight);
            console.log('originalContentHeight + contentHeight', originalContentHeight + contentHeight);
            hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) + Number(contentHeight)}px`);
            if (header.classList.contains('active')) {
              hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) + Number(contentHeight)}px`);
            } else {
              hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) - Number(contentHeight)}px`);
            }
          } else {
            hasParentAccordion.style.setProperty('--content-height', `${Number(contentHeight)}px`);
          }
        }
      }

      if (isTabItemAccordionFirst) {
        header.classList.add('active');
        content.classList.add('active');

        if (hasParentAccordion) {

          const originalContentHeight = hasParentAccordion.style.getPropertyValue('--content-height').replace('px', '');
          console.log(originalContentHeight, 'originalContentHeight');

          if (originalContentHeight) {
            console.log('contentHeight', contentHeight);
            console.log('originalContentHeight + contentHeight', originalContentHeight + contentHeight);
            hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) + Number(contentHeight)}px`);
            if (header.classList.contains('active')) {
              hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) + Number(contentHeight)}px`);
            } else {
              hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) - Number(contentHeight)}px`);
            }
          } else {
            hasParentAccordion.style.setProperty('--content-height', `${Number(contentHeight)}px`);
          }
        }
      }

      header.addEventListener('click', () => {
        header.classList.toggle('active');
        content.classList.toggle('active');
        if (hasParentAccordion) {

          const originalContentHeight = hasParentAccordion.style.getPropertyValue('--content-height').replace('px', '');
          console.log(originalContentHeight, 'originalContentHeight');

          if (originalContentHeight) {
            console.log('contentHeight', contentHeight);
            console.log('originalContentHeight + contentHeight', originalContentHeight + contentHeight);
            hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) + Number(contentHeight)}px`);
            if (header.classList.contains('active')) {
              hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) + Number(contentHeight)}px`);
            } else {
              hasParentAccordion.style.setProperty('--content-height', `${Number(originalContentHeight) - Number(contentHeight)}px`);
            }
          } else {
            hasParentAccordion.style.setProperty('--content-height', `${Number(contentHeight)}px`);
          }
        }
        if (downloadSection && isTabItemAccordion && header.classList.contains('active')) {
          allTabItemAccordions.forEach(accordion => {
            if (accordion === this) return;

            const accordionHeader = accordion.querySelector('.yg-accordion-header');
            const accordionContent = accordion.querySelector('.yg-accordion-content');

            if (!accordionHeader || !accordionContent) return;

            if (accordionHeader.classList.contains('active') || accordionContent.classList.contains('active')) {
              accordionHeader.classList.remove('active');
              accordionContent.classList.remove('active');

              const retractableTab = accordion.parentNode.closest('.yg-accordion');
              if (retractableTab) {
                const retractableOriginalHeight = parseFloat(retractableTab.style.getPropertyValue('--content-height')) || 0;
                const accordionContentHeight = parseFloat(accordion.style.getPropertyValue('--content-height')) || accordionContent.scrollHeight || 0;
                const nextHeight = Math.max(retractableOriginalHeight - accordionContentHeight, 0);
                retractableTab.style.setProperty('--content-height', `${nextHeight}px`);
              }
            }
          });
        }
      });
    }
  }

  if (!window.customElements.get('yg-accordion')) {
    window.customElements.define('yg-accordion', YGAccordion);
  }
  class YGDownload extends HTMLElement {
    constructor() {
      super();
      this.init()
    }

    fileDownload(url, name) {
      this.classList.add('active');
      fetch(url)
        .then(response => {
          const contentType = response.headers.get("content-type");
          let fileExtension = "";
          if (contentType.includes("application")) {
            fileExtension = contentType.split("/")[1];
          } else if (contentType.includes("image")) {
            fileExtension = contentType.split("/")[1];
          }
          return response.arrayBuffer().then(buffer => ({ buffer, extension: fileExtension }));
        })
        .then(({ buffer, extension }) => {
          const blob = new Blob([buffer], { type: 'application/octet-stream' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${name}.${extension}`); // 替换为期望的下载文件名
          document.body.appendChild(link);
          link.click();
          this.classList.remove('active');
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }).catch(error => {
          console.error('Error fetching the file:', error);
        });
    }
    init() {
      this.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.getAttribute('data-link') != '' && this.getAttribute('data-file-name') != '#') {
          this.fileDownload(this.getAttribute('data-link'), this.getAttribute('data-file-name'))
        }

      });
    }
  }

  if (!window.customElements.get('yg-download')) {
    customElements.define('yg-download', YGDownload);
  }

  class YGInfoAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const header = this.querySelector(".yg-accordion-header");
      const content = this.querySelector(".yg-accordion-content");
      const trueHeight = content.scrollHeight;
      content.style.setProperty("--true-height", `${trueHeight}px`);
      header.addEventListener("click", () => {
        this.classList.toggle("yg-accordion-open");
      });
    }
  }

  if (!window.customElements.get("yg-info-accordion")) {
    window.customElements.define("yg-info-accordion", YGInfoAccordion);
  }

  class YGMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.tabs = null;
      this.items = null;
      this.tabHandlers = [];
      this.handleResize = this.handleResize.bind(this);
      this.init();
    }
    init() {
      this.tabs = this.querySelectorAll('.yg-collection-tab-item');
      this.items = this.querySelectorAll('.yg-collection-product-item');
      if (this.tabs.length === 0 || this.items.length === 0) return;

      // 初始化高亮和展示
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('active', i === 0);
        if (this.items[i]) this.items[i].classList.toggle('active', i === 0);
      });

      // 根据屏幕宽度设置事件
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }

    switchTab(index) {
      this.tabs.forEach((t, j) => t.classList.toggle('active', index === j));
      this.items.forEach((p, j) => p.classList.toggle('active', index === j));
    }

    handleResize() {
      const isMobile = window.innerWidth < 1150;

      // 清除现有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
      this.tabHandlers = [];

      // 根据设备类型添加事件
      this.tabs.forEach((tab, i) => {
        let handler;
        let type;

        if (isMobile) {
          // 移动端：点击切换
          type = 'click';
          handler = () => this.switchTab(i);
        } else {
          // 桌面端：悬浮切换
          type = 'mouseenter';
          handler = () => this.switchTab(i);
        }

        tab.addEventListener(type, handler);
        this.tabHandlers.push({ tab, handler, type });
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      // 清除所有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
    }
  }
  if (!window.customElements.get('yg-mega-menu')) {
    window.customElements.define('yg-mega-menu', YGMegaMenu);
  }

  class YGColectionProducts extends HTMLElement {
    constructor() {
      super();
      this.initSwiper();
    }

    initSwiper() {
      new Swiper(this, {
        slidesPerView: 2,
        spaceBetween: 10,

      })
    }
  }

  if (!window.customElements.get('yg-colection-products')) {
    window.customElements.define('yg-colection-products', YGColectionProducts);
  }
})






